export const NAV_CATEGORY = {
  Production: {
    label: '产品与服务',
    value: 1,
  },
  Solution: {
    label: '解决方案',
    value: 2,
  },
  Resource: {
    label: '资源中心',
    value: 3,
  },
  Pricing: {
    label: '价格',
    value: 4,
  },
  Cooperation: {
    label: '合作伙伴',
    value: 5,
  },
  News: {
    label: '新闻',
    value: 6,
  },
  About: {
    label: '关于',
    value: 7,
  },
};

export const NavSolutionItem = [
  { label: '全球扩张', href: '/solutions/global-expansion' },
  { label: '全球合规', href: '/solutions/compliant' },
  { label: '入职与算薪', href: '/solutions/onboarding' },
];

export const NavResourceItem = [
  { label: '雇佣指南', href: '/employment-guides' },
  {
    label: '成本计算器',
    href: '/tools/cost-calculator',
  },
];

export const NavAboutItem = [
  { label: '关于我们', href: '/about-us' },
  { label: '加入我们', href: '/careers' },
];

const NavConsulation = [
  {
    label: '出海调研与评估',
    href: '/products/overseas-expansion-research-and-evaluation',
  },
  {
    label: '出海战略规划',
    href: '/products/overseas-strategy-planning',
  },
  {
    label: '全球人力战略咨询',
    href: '/products/global-work-force-strategy-consulting',
  },
  {
    label: '全球人力资源管理',
    href: '/products/global-hr-management',
  },
];

const NavManagement = [
  { label: '名义雇主/EOR', href: '/products/eor' },
  {
    label: '全球灵活用工/Contractor',
    href: '/products/contractor',
  },
  {
    label: '共享HR/PEO',
    href: '/products/shared-hr-services',
  },
  {
    label: '人才猎聘',
    href: '/products/talent-recruitment',
  },
  {
    label: '全球工作签证',
    href: '/products/global-visa',
  },
  {
    label: '全球薪酬管理',
    href: '/products/global-payroll',
  },
];

const NavService = [
  {
    label: '海外公司注册及秘书服务',
    href: '/products/overseas-company-registration-and-secretarial-services',
  },
  {
    label: '全球合规咨询服务',
    href: '/products/global-compliance-advisory-services',
  },
  {
    label: '业务流程外包/BPO',
    href: '/products/business-process-outsourcing-bpo',
  },
  {
    label: '海外人事外包/HRO',
    href: '/products/overseas-human-resources-outsourcing-hro',
  },
];

export const NavPlatformMap = {
  label: '全球人力资源管理平台',
  href: '/products/global-human-resource-management-platform',
};

export const NavProductionList = [
  {
    title: '出海战略咨询',
    NavItem: NavConsulation,
  },
  {
    title: '海外用工管理',
    NavItem: NavManagement,
  },
  {
    title: '出海综合服务',
    NavItem: NavService,
  },
];
